import { EAnalyticsEvent, TrackTimeSpentOnSteps } from '~/enums';
import { isInIframe } from '~/iframeMode';
import { IGtmAnalyticEventParams } from '~/Interfaces';

export const pushToGtmHelper = (
  event: EAnalyticsEvent,
  key?: IGtmAnalyticEventParams
) => {
  const data = { event, eventName: event };

  window.dataLayer.push({ ...data, ...key, iframeMode: isInIframe });
};

export const shouldTrackTimeSpentOnStep = (
  actionName: string | undefined
): boolean => {
  if (!actionName) {
    return false;
  }

  return TrackTimeSpentOnSteps.includes(actionName);
};
